import React from 'react'

const Automation_Testing = () => {
  return (
    <div>
        {/* collapseThirtyThree */}
        <div className="accordion-item mb-2">
            <h2 className="accordion-header" id="headingThirtyThree">
                <button className="accordion-button collapsed d-flex justify-content-between align-items-center border py-2 fw-bold" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThirtyThree" aria-expanded="false" aria-controls="collapseThirtyThree">
                    Automation Testing
                    <span className="toggle-icon ms-auto"></span>
                </button>
            </h2>
            <div id="collapseThirtyThree" className="accordion-collapse collapse" aria-labelledby="headingThirtyThree" data-bs-parent="#accordionCourses">
                <div className="accordion-body overflow-auto" style={{ maxHeight: '200px' }}>
                    <strong>1) Introduction To Automation:</strong>
                    <ul>
                        <li>Introduction to automation</li>
                        <li>Benefits of Automation</li>
                        <li>Automation Test Process</li>
                    </ul>

                    <strong>2) Automation Tool Selenium:</strong>
                    <ul>
                        <li>Introduction to Selenium</li>
                        <li>Components of Selenium</li>
                        <li>Web Element in Selenium</li>
                        <li>Action Class</li>
                        <li>X-Path in Selenium (Theory and Practical)</li>
                    </ul>
                    <strong>3) Selenium IDE:</strong>
                    <ul>
                        <li>Introduction to IDE</li>
                        <li>Installation and setup of IDE</li>
                        <li>Practical on IDE (Creation of Script and Execution)</li>
                    </ul>

                    <strong>4) Selenium Web-Driver:</strong>
                    <ul>
                        <li>Introduction to Web-Driver</li>
                        <li>Difference between Web-Driver and RC</li>
                        <li>Installation of Eclipse and JAVA</li>
                        <li>Installation of Web-Driver</li>
                        <li>Creation of First Script in Web-Driver</li>
                        <li>Practical Sessions</li>
                    </ul>
                    <strong>5) Frameworks in Selenium:</strong>
                    <ul>
                        <li>What is Framework?</li>
                        <li>Data Driven Framework</li>
                        <li>Keyword Driven Framework</li>
                        <li>Hybrid Framework</li>
                    </ul>
                    <strong>6) TestNG Framework:</strong>
                    <ul>
                        <li>What is TestNG?</li>
                        <li>Why it is used?</li>
                        <li>Installation of TestNG with Eclipse</li>
                        <li>Creating First Script using TestNG</li>
                        <li>Generating Report</li>
                    </ul>
                    <strong>7) Apache Jmeter:</strong>
                    <ul>
                        <li>Introduction to Apache</li>
                        <li>Jmeter Installation of Jmeter</li>
                        <li>Practical Session on Apache Jmeter</li>
                    </ul>
                    <strong>8) JIRA Software:</strong>
                    <ul>
                        <li>Install JIRA</li>
                        <li>JIRA Tool Elements</li>
                        <li>Creating Projects</li>
                        <li>Adding Users in JIRA</li>
                        <li>Managing JIRA Dashboard and Gadgets</li>
                        <li>Atlassian Marketplace for JIRA</li>
                    </ul>
                    <strong>9) API Testing:</strong>
                    <ul>
                        <li>Introduction to API Testing</li>
                        <li>Introduction & Installation to PostMan</li>
                        <li>Practical Implementation</li>
                    </ul>
                    <strong>10) Maven Project:</strong>
                    <ul>
                        <li>Introduction to Maven</li>
                        <li>Installation of Maven Project to Eclipse</li>
                        <li>Practical on Maven using Java Project</li>
                    </ul>
                    <strong>11) Jenkins in Selenium:</strong>
                    <ul>
                        <li>Introduction to Jenkins, Why to use</li>
                        <li>Setup of Jenkins in Eclipse</li>
                        <li>Execution of automation script using Jenkins</li>
                    </ul>
                    <strong>12) GIT:</strong>
                    <ul>
                        <li>Introduction to Git</li>
                        <li>How to Push, Pull, Commit Request in GitHub</li>
                        <li>Practical Session GitHub</li>
                    </ul>

                </div>
            </div>
        </div>

    </div>
  )
}

export default Automation_Testing